import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'sso-page',
    templateUrl: './sso.component.html'
})

export class SsoComponent implements OnInit {
    public url: string;

    constructor() {
    }

    ngOnInit() {
        this.url = localStorage.getItem('ssoUrl');        
        if (this.url) {
            localStorage.removeItem('ssoUrl');
            window.location.href = this.url;
        }
        else {
            let response: any = {};
            response.success = false;
            response.token = null;
            response.error = 'Failed';           
            Office.context.ui.messageParent(JSON.stringify(response));
        }
    }
}    